import styled from 'styled-components'

import { WalletAddressTruncated } from '../common/wallet-address-truncated'

import type { WalletAddress as WalletAddressValue } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  walletAddress: WalletAddressValue
  withCopy?: boolean
} & ClassNameProps

export const WalletAddress: React.FC<Props> = ({
  withCopy = true,
  ...props
}) => <Root {...props} withCopy={withCopy} />

const Root = styled(WalletAddressTruncated)`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
